import { render } from "./MapLegend.vue?vue&type=template&id=2ac21766&scoped=true"
import script from "./MapLegend.vue?vue&type=script&lang=js"
export * from "./MapLegend.vue?vue&type=script&lang=js"

import "./MapLegend.vue?vue&type=style&index=0&id=2ac21766&scoped=true&lang=css"

import exportComponent from "/Users/diekstra/PhpstormProjects/rbs-vlb-reservations/rvr-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac21766"]])

export default __exports__